// extracted by mini-css-extract-plugin
export default {"release_customers_table":"ReleaseCustomersTable_release_customers_table__RDZhp"};